//import { Component, OnInit } from '@angular/core';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';

const DOT = '.';

@Component({
  selector: 'mem-newlogin-loader',
  templateUrl: './newlogin-loader.component.html',
  styleUrls: ['./newlogin-loader.component.scss']
})
export class NewloginLoaderComponent implements OnInit {
  intervalHandler;
  loadingDots;
  circleAnimationClass: string;

  ngOnDestroy(): void {
    if (this.intervalHandler) {
      clearInterval(this.intervalHandler);
      this.intervalHandler = null;
    }
  }

  ngOnInit(): void {
    this.intervalHandler = setInterval(() => {
      if (this.loadingDots && this.loadingDots.length < 4) {
        this.loadingDots = this.loadingDots + DOT;
      } else {
        this.loadingDots = DOT;
      }

      this.circleAnimationClass = 'animation' + this.loadingDots.length;
    }, 500);
  }
}



// WEBPACK FOOTER //
// ./src/app/new-login/newlogin-loader/newlogin-loader.component.ts